import React from "react";
import { connect } from 'react-redux';

import { appActions } from '../../../core/app'

import { Dispatcher, Constants } from "../../../flux";

class NavbarToggle extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleMenu();
  }

  render() {
    return (
      <button onClick={this.handleClick} className="navbar-toggler d-md-none d-lg-none d-xl-none" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        	<span className="navbar-toggler-icon"></span>
    	</button>
    )
  }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  return {
  }
};

const mapDispatchToProps = {
  toggleMenu: appActions.toggleMenu,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavbarToggle);
